<script>
export default {
  props: ['disabled'],
}
</script>

<template>
  <div class="row g-3">
    <div class="col">
      <b-button class="w-100 form-control " type="button" @click="() => $emit('close')"
        variant="outline-danger">キャンセル</b-button>
    </div>
    <div class="col">
      <b-button type="button" :disabled="disabled" @click="() => $emit('submit')"
        class="w-100 form-control btn-lyg" variant="primary">保存</b-button>
    </div>
  </div>
</template>
